import { call, put, takeLatest, delay } from 'redux-saga/effects';
import { USERS } from 'src/store/ActionTypes';
import * as api from 'src/store/api';

function* fetchAgencies(action) {
  try {
    const agencies = yield call(api.getAgencies, action.payload);
    yield put({
      type: USERS.FETCH_AGENCIES_SUCCEEDED,
      payload: agencies,
    });
  } catch (e) {
    yield put({
      type: USERS.FETCH_AGENCIES_FAILED,
      payload: e,
    });
  }
}

function* fetchUsers(action) {
  try {
    const users = yield call(api.getUsers, action.payload);
    yield put({
      type: USERS.FETCH_USERS_SUCCEEDED,
      payload: users,
    });
  } catch (e) {
    yield put({
      type: USERS.FETCH_USERS_FAILED,
      payload: e,
    });
  }
}

function* addUser(action) {
  try {
    yield call(api.addUser, action.payload);
    yield put({
      type: USERS.ADD_USER_SUCCEEDED,
    });
    yield* fetchUsers();
  } catch (e) {
    yield put({
      type: USERS.ADD_USER_FAILED,
      payload: e,
    });
  } finally {
    delay(500);
    yield put({
      type: USERS.UNSET,
      payload: 'addUserStatus',
    });
  }
}

function* editUser(action) {
  try {
    const { userId, user } = action.payload;
    yield call(api.editUser, userId, user);
    yield put({
      type: USERS.EDIT_USER_SUCCEEDED,
    });
    yield* fetchUsers();
  } catch (e) {
    yield put({
      type: USERS.EDIT_USER_FAILED,
      payload: e,
    });
  } finally {
    delay(500);
    yield put({
      type: USERS.UNSET,
      payload: 'editUserStatus',
    });
  }
}

function* deactivateUser(action) {
  try {
    yield call(api.deactivateUser, action.payload);
    yield put({
      type: USERS.DEACTIVATE_USER_SUCCEEDED,
    });
    yield* fetchUsers();
  } catch (e) {
    yield put({
      type: USERS.DEACTIVATE_USER_FAILED,
      payload: e,
    });
  } finally {
    delay(500);
    yield put({
      type: USERS.UNSET,
      payload: 'deactivateUserStatus',
    });
  }
}

function* activateUser(action) {
  try {
    yield call(api.activateUser, action.payload);
    yield put({
      type: USERS.ACTIVATE_USER_SUCCEEDED,
    });
    yield* fetchUsers();
  } catch (e) {
    yield put({
      type: USERS.ACTIVATE_USER_FAILED,
      payload: e,
    });
  } finally {
    delay(500);
    yield put({
      type: USERS.UNSET,
      payload: 'activateUserStatus',
    });
  }
}

function* fetchAgenciesSaga() {
  yield takeLatest(USERS.FETCH_AGENCIES, fetchAgencies);
}

function* fetchUsersSaga() {
  yield takeLatest(USERS.FETCH_USERS, fetchUsers);
}

function* addUserSaga() {
  yield takeLatest(USERS.ADD_USER, addUser);
}

function* editUserSaga() {
  yield takeLatest(USERS.EDIT_USER, editUser);
}

function* deactivateUserSaga() {
  yield takeLatest(USERS.DEACTIVATE_USER, deactivateUser);
}

function* activateUserSaga() {
  yield takeLatest(USERS.ACTIVATE_USER, activateUser);
}

export default [
  fetchAgenciesSaga(),
  fetchUsersSaga(),
  addUserSaga(),
  editUserSaga(),
  deactivateUserSaga(),
  activateUserSaga(),
];
